import React from 'react';
import "./myprofile.scss";
import ProfileCard from './profileCard';

const Myprofile = () => {
    return (
        <div className="my-profile">
            <div className="profile-card">
                <ProfileCard />
            </div>
        </div>
    )
}

export default Myprofile